(function (Drupal, $, once) {
  Drupal.behaviors.bookNavigation = {
    attach: function (context) {
      $(function() {
        once('book-navigation', $('#block-msfmg-book-navigation')).forEach(function (element) {
          var $this = $(element);
          var mobNav = $this.children('.book-nav-mobile');
          var activeItems = $this.find('.menu-item--active-trail');

          mobNav.append(activeItems.first().clone().children('a'));

          if(activeItems.length > 1) {
            mobNav.append(activeItems.last().clone().children('a'));
          }

          //add collapse button +/-
          $this.find('.menu-item').children('.collapse-controls').remove();
          $this.find('.menu-item.menu-item--expanded.menu-item--active-trail').append('<div class="collapse-controls"></div>')
          $(document).on('click', '.menu-item.menu-item--expanded >.collapse-controls', function(){
            var speed = Math.round($(this).siblings('.menu').outerHeight()/15); //slowing animation on long lists
            $(this).siblings('.menu').stop().slideToggle(300 + speed)
            $(this).toggleClass('closed');
          })

          //no active trail
          if(activeItems.length < 1) {
            mobNav.append('<div>'+$('.guideline-switcher__title .active').text()+'</div>');
          }

          mobNav.on('click', function () {
            $(this).toggleClass('is-open');
            $(this).siblings('ul.menu').stop().slideToggle(300);
          })

          // get the sticky element
          if($(window).width() < 1024) {
            // setTimeout(() => {
            //   $('#block-msfmg-page-title').css('top', ($('.region.region-sidebar').height()-2) + 'px');
            // }, 300);

            var stickyElm = $('.layout-sidebar')[0];
            // var stickyElm2 = $('#block-msfmg-page-title')[0];

            var observer = new IntersectionObserver(
              ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
              {threshold: [1]}
              );

            observer.observe(stickyElm);
            // observer.observe(stickyElm2);
          }
        })
      })
    }
  }
})(Drupal, jQuery, once);
